import { z } from "zod";

export const updateInitialVehicleRestitutionPayload = z.object({
  restitutionUuid: z.uuid(),
  driverUuid: z.uuid(),
  mileage: z.number(),
  isCabinCleaned: z.boolean(),
  isTrunkCleaned: z.boolean(),
  observations: z.string().nullable(),
  departureLocation: z.string(),
  furthestDestination: z.string().nullable(),
  pictures: z.array(z.uuid()),
  picturesToUpload: z.array(
    z.object({
      originalFileName: z.string(),
      fileBuffer: z.string(),
    }),
  ),
});

export type UpdateInitialVehicleRestitutionPayload = z.infer<
  typeof updateInitialVehicleRestitutionPayload
>;
